import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "./redux/userSlice";
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import Dashboard from "./pages/Dashboard";
import Dashboard2 from "./pages/Dashboard-2";
import ProfileManagement from "./pages/EditProfile";
import AddAssets from "./pages/AddAssets";
import NotFound from "./pages/NotFound";
import HomePage from "./pages/HomePage";
import MyAssets from "./pages/MyAssets";
import CallbackPage from "./pages/CallbackPage";
import LiabilityFormPage from "./pages/LiabilityFormPage";
import MyLiability from "./pages/MyLiability";
import AssetDetails from "./pages/AssetDetails";
import Notifications from "./pages/Notifications";
import Collaborators from "./pages/Collaborators";
import SharedWithYou from "./pages/SharedWithYou";
import Reminder from "./pages/Reminder";


// PrivateRoute component with phone verification
function PrivateRoute({ children, requirePhone = true }) {
  const isAuthenticated = !!localStorage.getItem('access_token');
  const user = useSelector((state) => state.user?.data);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requirePhone) {
    // Check if phone is linked (same logic as Dashboard.js)
    const identities = Array.isArray(user?.identities) ? user.identities : [];
    const smsIdentities = identities.filter(id => id.provider === 'sms');
    const hasPhone = smsIdentities.length > 0;

    if (!hasPhone) {
      // Check if account is past 7-day grace period
      const accountCreatedAt = user?.createdAt;
      if (accountCreatedAt) {
        const createdDate = new Date(accountCreatedAt);
        const now = new Date();
        const accountAgeDiff = now - createdDate;
        const accountAgeDays = Math.ceil(accountAgeDiff / (1000 * 60 * 60 * 24));

        // If account is 7+ days old and no phone linked, enforce verification
        if (accountAgeDays >= 7) {
          return <Navigate to="/dashboard" replace />;
        }
      }
      // Within grace period or no createdAt - allow access (modal will show on dashboard)
    }
  }

  return children;
}

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      dispatch(setUser(JSON.parse(user)));
    }
  }, [dispatch]);
  return (
    <>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/callback" element={<CallbackPage />} />
        <Route path="/home" element={<PrivateRoute><HomePage /></PrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute requirePhone={false}><Dashboard /></PrivateRoute>} />
        <Route path="/dashboard-2" element={<PrivateRoute requirePhone={false}><Dashboard2 /></PrivateRoute>} />
        <Route path="/editprofile" element={<PrivateRoute><ProfileManagement /></PrivateRoute>} />
        <Route path="/add-assets" element={<PrivateRoute><AddAssets /></PrivateRoute>} />
        <Route path="/my-assets" element={<PrivateRoute><MyAssets /></PrivateRoute>} />
        <Route path="/my-assets/:assetId" element={<PrivateRoute><AssetDetails /></PrivateRoute>} />
        <Route path="/add-liability" element={<PrivateRoute><LiabilityFormPage /></PrivateRoute>} />
        <Route path="/my-liability/:id" element={<PrivateRoute><LiabilityFormPage /></PrivateRoute>} />
        <Route path="/my-liability" element={<PrivateRoute><MyLiability /></PrivateRoute>} />
        <Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
        <Route path="/collaborators" element={<PrivateRoute><Collaborators /></PrivateRoute>} />
        <Route path="/reminder" element={<PrivateRoute><Reminder /></PrivateRoute>} />
        <Route path="/shared-with-you" element={<PrivateRoute><SharedWithYou /></PrivateRoute>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ToastContainer />
    </>
  );
}

export default App;
